import { render, staticRenderFns } from "./CardPinUnpinButton.vue?vue&type=template&id=40bd0cc3&"
import script from "./CardPinUnpinButton.vue?vue&type=script&lang=js&"
export * from "./CardPinUnpinButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40bd0cc3')) {
      api.createRecord('40bd0cc3', component.options)
    } else {
      api.reload('40bd0cc3', component.options)
    }
    module.hot.accept("./CardPinUnpinButton.vue?vue&type=template&id=40bd0cc3&", function () {
      api.rerender('40bd0cc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/CardPinUnpinButton.vue"
export default component.exports